var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('div',{staticClass:"measure-result"},[_vm._v("\n    "+_vm._s(_vm.$t('LENGTH'))+": "+_vm._s(_vm.distance)+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"measure-result"},[_vm._v("\n    "+_vm._s(_vm.$t('AREA'))+": "+_vm._s(_vm.area)+"\n  ")])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33cd0378","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/measuretool/MeasureResult.vue
// module id = vDSi
// module chunks = 1